import { useMutation } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'
import useVariantsToApproveQuery from 'features/unifiedFlow/contentPage/hooks/useVariantsToApproveQuery'

import { VariantStatusUpdate } from '../../interfaces'
import { updateVariantStatus } from '../api'

const useUpdateVariantStatus = ({
  campaignId,
  updateResultsVariantStatus,
}: {
  campaignId: string
  updateResultsVariantStatus: (variantId: string, variantStatus: string) => void
}) => {
  const { invalidateAll: invalidateAllVariantsToApproveCountQuery } =
    useVariantsToApproveQuery()

  return useMutation({
    mutationFn: ({ id, variantStatus }: VariantStatusUpdate) =>
      updateVariantStatus(id, campaignId, variantStatus),
    onError: () => errorToast('Something went wrong. Please try again.'),
    onSuccess(data, { id, variantStatus }) {
      updateResultsVariantStatus(id, variantStatus)
      invalidateAllVariantsToApproveCountQuery()
      successToast('Variant status updated successfully.')
    },
  })
}

export default useUpdateVariantStatus
